let lang = {

	"profession": "Desenvolvedor de sistemas",
	"university": "Universidade do Estado de Minas Gerais",

};

export default lang;
